
import { defineComponent } from 'vue';
import TrailMenu from '@/components/TrailMenu.vue'; // @ is an alias to /src
import TrailInformation from '@/components/TrailInformation.vue';
import TrailReactions from '@/components/TrailReactions.vue';
import ModalMessage from '@/components/ModalMessage.vue';
import TrailUnAuthorizedOptions from '@/components/TrailUnAuthorizedOptions.vue';
import store from '@/store';

export default defineComponent({
  name: 'TrailView',
  components: {
    TrailMenu,
    TrailInformation,
    TrailReactions,
    ModalMessage,
    TrailUnAuthorizedOptions,
  },
  data() {
    return {
      showNotLoggedIn: false,
    };
  },
  methods: {
    toggleShowNotLoggedIn() {
      this.showNotLoggedIn = !this.showNotLoggedIn;
    },
  },
  props: {
    trailid: String,
  },
  created() {
    store.dispatch('getTrailIntroduction', this.trailid);
  },
  computed: {
    currentTrail() {
      return store.state.trailinfo;
    },
  },
});
